import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { userPipe } from './user-pipe/user-filter.pipe';
import { userNamePipe } from './userName-pipe/userName-filter.pipe';
import { DataFilterPipe } from './dataFilter-pipe/dataFilter-filter.pipe';
import { namePipe } from './name-pipe/name-filter.pipe';
import { descPipe } from './description-pipe/description-filter.pipe';
import { DateTimeAgoPipe } from './date-time-ago/date-time-ago.pipe';
import { TutorialFilterPipe } from './tutorial-pipe/tutorial-filter.pipe';

@NgModule({
  declarations: [
    userPipe,
    DataFilterPipe,
    namePipe,
    descPipe,
    userNamePipe,
    DateTimeAgoPipe,
    TutorialFilterPipe,
  ],
  exports: [
    userPipe,
    DataFilterPipe,
    namePipe,
    descPipe,
    userNamePipe,
    DateTimeAgoPipe,
    TutorialFilterPipe,
  ],
  imports: [
    CommonModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PipesModule { }